module.exports = __webpack_public_path__ + "static/media/mountain_biking.77b439b2.webp";